import * as i0 from '@angular/core';
import { input, computed, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { PodiumComponent } from '@futura/futura-ui/podium';
import { getIconInfo } from '@futura/futura-ui/core';
function PodiumIconComponent_ng_template_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_4_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("fontSet", (tmp_3_0 = ctx_r0.internalIcon()) == null ? null : tmp_3_0.fontSet);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate((tmp_4_0 = ctx_r0.internalIcon()) == null ? null : tmp_4_0.icon);
  }
}
function PodiumIconComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PodiumIconComponent_ng_template_1_Conditional_0_Template, 2, 2, "mat-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.internalIcon() ? 0 : -1);
  }
}
let PodiumIconComponent = /*#__PURE__*/(() => {
  class PodiumIconComponent {
    constructor() {
      this.state = input();
      this.icon = input.required();
      this.type = input('primary');
      this.dashed = input(false);
      this.internalIcon = computed(() => {
        const iconInfo = this.icon();
        if (!iconInfo) {
          return null;
        }
        return getIconInfo(iconInfo);
      });
    }
    static {
      this.ɵfac = function PodiumIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PodiumIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PodiumIconComponent,
        selectors: [["fut-podium-icon"]],
        inputs: {
          state: [1, "state"],
          icon: [1, "icon"],
          type: [1, "type"],
          dashed: [1, "dashed"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 4,
        consts: [["podiumIcon", ""], [3, "state", "type", "text", "dashed"], [3, "fontSet"]],
        template: function PodiumIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "fut-podium", 1);
            i0.ɵɵtemplate(1, PodiumIconComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const podiumIcon_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("state", ctx.state())("type", ctx.type())("text", podiumIcon_r2)("dashed", ctx.dashed());
          }
        },
        dependencies: [MatIcon, PodiumComponent]
      });
    }
  }
  return PodiumIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { PodiumIconComponent };
